import { ActionTree, GetterTree, Module, MutationTree } from 'vuex';

export const APP_PLATFORM = 'webapp';
export const APP_VERSION = process.env.VERSION;
export const APP_COMMIT_HASH = BUILD_CONFIG.commitShortHash;

// STATE
const state = () => ({
	seoUser: true,
	xServeTrack: null as string | null,
	ssrTodaysDate: null as string | null,
	isUsingAdBlocker: false,
});

export type AppState = ReturnType<typeof state>;

// GETTERS
const getters: GetterTree<AppState, any> = {
	isSeoUser(state) {
		return state.seoUser;
	},

	xServeTrack(state): string | null {
		return state.xServeTrack;
	},

	ssrTodaysDate(state): string | null {
		return state.ssrTodaysDate;
	},

	isUsingAdBlocker(state) {
		return state.isUsingAdBlocker;
	},
};

// ACTIONS
const actions: ActionTree<AppState, any> = {
	setSeoUser({ commit }, value: boolean) {
		commit('SET_SEO_USER', value);
	},

	setXServeTrack({ commit }, value: string | null) {
		commit('SET_X_SERVE_TRACK', value);
	},

	setSSRTodaysDate({ commit, state }, value: string | null) {
		if (process.server && !state.ssrTodaysDate) {
			commit('SET_TODAY_SSR_DATE', value);
		}
	},

	setIsUsingAdBlocker({ commit }, value: boolean) {
		commit('SET_IS_USING_AD_BLOCKER', value);
	},
};

// MUTATIONS
const mutations: MutationTree<AppState> = {
	SET_SEO_USER(state, value: boolean) {
		state.seoUser = value;
	},

	SET_X_SERVE_TRACK(state, value: string | null) {
		state.xServeTrack = value;
	},

	SET_TODAY_SSR_DATE(state, value: string | null) {
		state.ssrTodaysDate = value;
	},

	SET_IS_USING_AD_BLOCKER(state, value: boolean) {
		state.isUsingAdBlocker = value;
	},
};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations,
} as Module<AppState, any>;
